<template>
  <div>
    <v-container v-if="pageLoading" grid-list-xl text-xs-center>
      <v-layout>
        <v-flex>
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <v-alert
      :value="true"
      type="info"
      v-if="!available_enrollment && !pageLoading && !portfolio"
    >
        En este momento no hay matriculas activas.
    </v-alert> -->
    <v-alert
      :value="true"
      type="warning"
      v-if="incompleted_induction && !pageLoading && !portfolio"
    >
      <b>{{ $t(`enrollments.attention`) }}</b> {{ $t(`enrollments.lecture`)
      }}<br /><br />
      <b
        >Haga clic
        <!-- <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSf8G1Jpm8hY63QnqGW_HHj8abrnUaKETSQH_jknJ7wgCqCakg/viewform"
          target="blank"
          >aquí</a
        > -->
        <a
          href="https://myemail-api.constantcontact.com/-ltima-oportunidad--Requisitos-Matr-cula-A-o-Escolar-2024-2025---Last-Chance--Requirements-for-Registrations-SY-2024-2025.html?soid=1101453042045&aid=8x3QeeEgUxg"
          target="blank"
          >aquí</a
        >
        para acceder.</b
      >
    </v-alert>
    <v-stepper v-if="!incompleted_induction" alt-labels v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
          @click="goToNextStep(1)"
          style="cursor: pointer;"
          >{{ $t(`enrollments.steps.children`) }}</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">{{
          $t(`enrollments.steps.documents`)
        }}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">{{
          $t(`enrollments.steps.confirm`)
        }}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 4" step="4">{{
          $t(`enrollments.steps.payment`)
        }}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 5" step="5">{{
          $t(`enrollments.steps.asopaf`)
        }}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 6" step="6">{{
          $t(`enrollments.steps.sign_book`)
        }}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          v-if="has_survey && !is_enrollment_survey"
          :complete="e1 > 7"
          :step="has_survey && !is_enrollment_survey ? '7' : ''"
          >{{ $t(`enrollments.steps.survey`) }}</v-stepper-step
        >
        <v-divider v-if="has_survey"></v-divider>

        <v-stepper-step
          :complete="e1 > allyStepValidation"
          :step="has_survey && !is_enrollment_survey ? '8' : '7'"
          >{{ $t(`enrollments.steps.allies`) }}</v-stepper-step
        >
        <v-divider v-if="yearly_payment"></v-divider>

        <v-stepper-step
          v-if="yearly_payment"
          :complete="e1 > yearlyStepValidation"
          :step="has_survey && !is_enrollment_survey ? '9' : '8'"
          >{{ $t(`enrollments.steps.yearly_payment`) }}</v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <enrollment-info
          :step="e1"
          :system_access="system_access"
        ></enrollment-info>
        <v-stepper-content step="1">
          <enrollment-step-1
            v-if="enrollment_id"
            v-on:goToNextStep="goToNextStep"
            :system_access="system_access"
            :allyStep="allyStepValidation"
            :yearlyStep="yearlyStepValidation"
            :hasSurvey="has_survey"
            :enrollmentSurvey="enrollmentSurvey"
          ></enrollment-step-1>
        </v-stepper-content>

        <v-stepper-content step="2">
          <enrollment-step-2
            v-if="enrollment_id"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-2>
        </v-stepper-content>

        <v-stepper-content step="3">
          <enrollment-step-3
            :actualStep="e1"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-3>
        </v-stepper-content>

        <v-stepper-content step="4">
          <enrollment-step-4
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-4>
        </v-stepper-content>

        <v-stepper-content step="5">
          <enrollment-step-4-allies
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-4-allies>
        </v-stepper-content>

        <v-stepper-content step="6">
          <enrollment-step-5
            :hasSurvey="has_survey"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-5>
        </v-stepper-content>

        <v-stepper-content
          v-if="has_survey && !is_enrollment_survey"
          :step="has_survey && !is_enrollment_survey ? '7' : ''"
        >
          <enrollment-step-7-survey
            :survey_id="survey_id"
            :actualStep="e1"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-7-survey>
        </v-stepper-content>

        <v-stepper-content
          :step="has_survey && !is_enrollment_survey ? '8' : '7'"
        >
          <enrollment-step-6
            :hasSurvey="has_survey"
            :isEnrollmentSurvey="is_enrollment_survey"
            :system_access="system_access"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-6>
        </v-stepper-content>

        <v-stepper-content
          v-if="yearly_payment"
          :step="has_survey && !is_enrollment_survey ? '9' : '8'"
        >
          <enrollment-step-7
            :system_access="system_access"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></enrollment-step-7>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import axios from "axios";
import enrollmentStep1 from "./enrollment_step1.vue";
import enrollmentStep2 from "./enrollment_step2.vue";
import enrollmentStep3 from "./enrollment_step3.vue";
import enrollmentStep4 from "./enrollment_step4.vue";
import enrollmentStep5 from "./enrollment_step5.vue";
import enrollmentStep6 from "./enrollment_step6.vue";
import enrollmentStep7 from "./enrollment_step7.vue";
import enrollmentStep4Allies from "./enrollment_step4_allies.vue";
import enrollmentStep7survey from "./enrollment_step7_survey.vue";
import enrollmentInfo from "./enrollment_info";
export default {
  name: "student-enrollment-view",
  components: {
    "enrollment-step-1": enrollmentStep1,
    "enrollment-step-2": enrollmentStep2,
    "enrollment-step-3": enrollmentStep3,
    "enrollment-step-4": enrollmentStep4,
    "enrollment-step-4-allies": enrollmentStep4Allies,
    "enrollment-step-5": enrollmentStep5,
    "enrollment-step-6": enrollmentStep6,
    "enrollment-step-7": enrollmentStep7,
    "enrollment-step-7-survey": enrollmentStep7survey,
    "enrollment-info": enrollmentInfo
  },
  created() {
    this.getAvailableEnrollments();
  },
  data() {
    return {
      e1: 1,
      enrollmentSurvey: {},
      pageLoading: true,
      // pass_validations: false,
      // type_enrollment: '',
      start_date_extemporaneuos: "",
      finish_date_extemporaneuos: "",
      enrollment_id: 0,
      // extemp_range: 0,
      system_access: false,
      available_enrollment: false,
      incompleted_induction: false,
      survey_id: 0,
      is_enrollment_survey: false,
      has_survey: false,
      yearly_payment: false
    };
  },
  computed: {
    allyStepValidation() {
      return this.has_survey && !this.is_enrollment_survey ? 8 : 7;
    },
    yearlyStepValidation() {
      return this.has_survey && !this.is_enrollment_survey ? 9 : 8;
    }
  },
  watch: {
    enrollment_id(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.fetchSons();
      }
    }
  },
  methods: {
    goToNextStep(step) {
      if (step == 1 && this.system_access) {
        this.$store.dispatch("fetchSons", {
          enrollment_id: this.enrollment_id
        });
        this.getAvailableEnrollments();
      }
      this.e1 = step;
    },
    goToPrevStep(step) {
      if (step == 1 && this.system_access) {
        this.$store.dispatch("fetchSons", {
          enrollment_id: this.enrollment_id
        });
        this.getAvailableEnrollments();
      }
      this.e1 = step;
    },
    fetchSons() {
      if (this.enrollment_id && this.enrollment_id > 0) {
        this.$store.dispatch("fetchSons", {
          enrollment_id: this.enrollment_id
        });
      }
    },
    getAvailableEnrollments() {
      this.$store.commit("CLEAR_ENROLLMENT_PROCESS");
      axios
        .get("/api/enrollment/start/initialValidations")
        .then(resp => {
          if (resp.status === 200) {
            this.pageLoading = false;

            const { data: validation } = resp;

            if (validation.survey_id) {
              this.survey_id = validation.survey_id;
              // this.is_survey_enrollmet = validation.survey_id
              this.has_survey = true;
            }
            this.yearly_payment = validation.yearly_payment_enabled;

            this.$store.commit(
              "SET_YEARLY_PAYMENT",
              validation.yearly_payment_enabled
            );
            this.$store.commit("SET_PORTFOLIO", validation.cartera);

            this.$store.commit(
              "SET_EXTEMP_DETAIL",
              validation.extemporaneous_with_access
            );

            this.$store.commit(
              "SET_EXTERNAL_PAYMENT",
              validation.external_payment
            );
            this.$store.commit(
              "SET_EXTERNAL_PAYMENT_DETAIL",
              validation.family_external_payment
            );
            this.$store.commit("SET_ENROLLMENT_YEAR", validation.school_year);

            this.$store.commit("POSITIVE_BALANCE", {
              active: validation.positive_balance,
              value: validation.positive_balance_value
            });
            this.$store.commit(
              "SET_STUDENTS_ACCESS",
              validation.system_access_student
            );

            this.$store.commit("SET_EXTEMP", {
              extempGen: validation.extemp_general === 1,
              extempConfig:
                validation.novelty_type === "EXTEMP" && this.system_access
            });

            this.$store.commit("FEE", {
              active: validation.fee,
              value: validation.fee_value
            });

            if (
              !validation.pass_validations ||
              validation.type_enrollment === "NONE"
            ) {
              this.available_enrollment = false;
              return;
            } else if (validation.enrollment_induction !== 1) {
              this.incompleted_induction = true;
            }

            this.available_enrollment = true;
            this.system_access = validation.system_access === 1;
            this.start_date_extemporaneuos = validation.start_date;
            this.finish_date_extemporaneuos = validation.finish_date;

            this.$store.dispatch("setEnrollmentId", {
              enrollment_id: validation.enrollment_id
            });
            this.enrollment_id = validation.enrollment_id;
            // console.log("validation", validation);
            this.erollmentSurveyValidation();
          }
        })
        .catch(error => console.log(error));
    },
    erollmentSurveyValidation() {
      if (this.survey_id !== 0) {
        axios
          .get(`/api/survey/${this.survey_id}`)
          .then(resp => {
            if (resp.status === 200) {
              const survey = resp.data;
              this.is_enrollment_survey =
                survey.is_enrollment !== null ? true : false;

              if (this.is_enrollment_survey) {
                this.enrollmentSurvey = survey.survey;
              }
              // console.log("this.enrollmentSurvey", JSON.parse(JSON.stringify(this.enrollmentSurvey)));
            }
          })
          .catch(error => console.log(error));
      } else {
        console.log("surveys not found");
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment.vue